import { render } from "./ChargingPrices.vue?vue&type=template&id=55665d41&scoped=true&ts=true&lang=html"
import script from "./ChargingPrices.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChargingPrices.vue?vue&type=script&lang=ts&setup=true"

import "./ChargingPrices.vue?vue&type=style&index=0&id=55665d41&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55665d41"]])

export default __exports__